export enum TypeClient {
  INDIVIDUAL = 'individual',
  JURIDICAL = 'juridical'
}

export const TYPE_CLIENT = {
  INDIVIDUAL: 'individual',
  JURIDICAL: 'juridical'
} as const

export const LABEL_TYPE_CLIENT = {
  INDIVIDUAL: 'Individual',
  JURIDICAL: 'Jurídico'
} as const

export const CATALOG_TYPE_CLIENT = [
  {
    value: TypeClient.INDIVIDUAL,
    label: LABEL_TYPE_CLIENT.INDIVIDUAL
  },
  {
    value: TypeClient.JURIDICAL,
    label: LABEL_TYPE_CLIENT.JURIDICAL
  }
]
